import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quickpay-settings-right-sidebar__contact-content" }
const _hoisted_2 = { class: "typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__contact-title" }
const _hoisted_3 = { class: "typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__contact-description" }
const _hoisted_4 = { class: "quickpay-settings-right-sidebar__faq-thumbnail" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "quickpay-settings-right-sidebar__faq-content" }
const _hoisted_7 = { class: "quickpay-settings-right-sidebar__faq-header" }
const _hoisted_8 = { class: "typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__faq-title" }
const _hoisted_9 = { class: "quickpay-settings-right-sidebar__faq-footer" }

import Card from 'vcomponents/common/card/Card.vue';
import { computed, inject } from 'vue';
import { Translator } from 'types/injects/translator.type';
import Feature from 'Services/Feature';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickpaySettingsRightSidebar',
  setup(__props) {

const $t = inject('$t') as Translator;

const translations = {
    contactTitle: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.title'),
    contactDescription: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.description'),
    contactCta: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.cta'),
    faqTitle: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.title'),
    faqLabel: $t.__('common.labels.faq'),
    faqCta: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.cta'),
    faqAlt: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.alt'),
};

const avatars = [
    {
        initials: 'S',
        fullName: 'Juliette E',
        photo: '/ressources/logged/img/common/avatars/juliette_e.png',
    },
    {
        initials: 'M',
        fullName: 'Raphaël D',
        photo: '/ressources/logged/img/common/avatars/raphael_d.png',
    },
];

const isContactUsEnabled = computed(() => {
    return Feature.isEnabled('quickpay-contact-us') && Feature.isEnabled('intercom');
});

return (_ctx: any,_cache: any) => {
  const _component_CompassAvatarGroup = _resolveComponent("CompassAvatarGroup")!
  const _component_CompassButton = _resolveComponent("CompassButton")!
  const _component_CompassPill = _resolveComponent("CompassPill")!
  const _component_CompassLink = _resolveComponent("CompassLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isContactUsEnabled.value)
      ? (_openBlock(), _createBlock(Card, {
          key: 0,
          class: "quickpay-settings-right-sidebar__contact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompassAvatarGroup, {
              size: "extra-large",
              avatars: avatars
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(translations.contactTitle), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_3, _toDisplayString(translations.contactDescription), 1 /* TEXT */),
              _createVNode(_component_CompassButton, {
                label: translations.contactCta,
                type: _ctx.CompassEnums.ButtonType.SECONDARY,
                class: "quickpay-settings-right-sidebar__contact-cta",
                leftIcon: "message",
                "data-intercom-target": "CSM Co"
              }, null, 8 /* PROPS */, ["label", "type"])
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(Card, { class: "quickpay-settings-right-sidebar__faq" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: "/ressources/logged/img/illustrations/payment/payment_faq.svg",
            alt: translations.faqAlt
          }, null, 8 /* PROPS */, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CompassPill, {
              label: translations.faqLabel,
              variant: _ctx.CompassEnums.PillVariant.PASTEL,
              color: _ctx.CompassEnums.PillColor.PURPLE,
              size: _ctx.CompassEnums.PillSize.EXTRA_SMALL
            }, null, 8 /* PROPS */, ["label", "variant", "color", "size"]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(translations.faqTitle), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_CompassLink, {
              label: translations.faqCta,
              link: "https://help.sellsy.com/fr/articles/14034096-paiements-en-ligne-guide-complet",
              target: "blank"
            }, null, 8 /* PROPS */, ["label"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}
}

})